module.exports = __webpack_public_path__ + "static/inghomepay-08916f326fc584a2e140a9ef9c957a3d.svg";